<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-row align-h="between" align-v="center">
              <h4 class="card-tittle">Ordenes de Taller</h4>
              <div class="justify-content-end">
                <b-button variant="danger" href="https://web.autorentas.cl/mantenciones/Ingreso.aspx" target="blank">Agendar Mantenimiento</b-button>
                <b-button
                    class="spacingButton"
                    variant="danger"
                    @click="getAllOrden()"
                >
                  <template v-if="!isBusyButtonAll">Exportar</template>
                  <b-spinner v-else small class="align-middle"></b-spinner>
                </b-button>
              </div>
            </b-row>
            <filters
                :filtros="filtros"
                :value="filtersValue"
                @change="getAllReports"
                patentView="getPatentsOrdenByRut"
              />
            <b-table
              :items="tableData"
              :fields="fields"
              :current-page="currentPage"
              :busy="isBusy"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              show-empty
            >
              <!-- Inicio Spinner en estado "ocupado" de la tabla -->
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <!-- Fin Spinner en estado "ocupado" de la tabla -->

              <template #cell(descarga)="row">
                <div class="text-center">
                  <b-button class="btn-sm" variant="danger" @click="downloadDocumento(row)" :disabled="!row.item.numeroOT">
                    <i
                        v-if="buttonClicked !== row.index"
                        class="bx bx-download font-size-16 align-middle"
                      />
                      <b-spinner v-else small class="align-middle"></b-spinner>
                  </b-button>
                  <b-tooltip target="download-div" triggers="hover" placement="rigth" v-if="!row.item.numeroOT">
                    No existen documentos disponibles
                  </b-tooltip>
                </div>
              </template>

              <template>
                  <h5 style="text-align: center">
                  {{ $t("request.table.empty") }}
                  </h5>
              </template>

              <template #cell(fechaTermino)="row">
                {{ getDate(row.value) }}
              </template>

              <template #cell(fechaInicio)="row">
                {{ getDate(row.value) }}
              </template>

              <template #cell(kilometraje)="row">
                {{ getNumberWithSeparators(row.value) }}
              </template>
              <template #cell(gps)="row">
                {{ row.value ? "Si" : "No" }}
              </template>
            </b-table>

            <!-- Inicio Paginación -->
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    class="portal"
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="totRegistros"
                  ></b-pagination>
                </ul>
              </div>
            </div>
            <!-- Fin Paginación -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import tableConfig from "./tableConfig";
import {getDateWithFormat, thousandSeparator} from "@/utils";
import axios from "@/axios";
import DPConfig from "../../../components/dataPickerConf";
import moment from "moment";
import Filter from "../../../components/filters/Filter";
import {toExcelThree} from "../../../utils";

export default {
  data() {
    return {
      sortBy: 'otNumero',
      sortDesc: true,
      lang: {
        formatLocale: DPConfig.formatLocale
      },
      patente: "",
      rutEmpresa: "",
      period: [new Date("2000-01-01"), new Date()],
      filtros: ['patent', 'rut', 'date'],
      filtersValue: {
        patent: "",
        rutEmpresa: "",
        period: [new Date("2000-01-01"), new Date()],
      },
      tableData: null,
      fields: tableConfig.fields,
      currentPage: 1,
      perPage: 1,
      pageOptions: [10, 25, 50, 100],
      totRegistros: 1,
      buttonClicked: false,
      isBusy: false,
      isBusyButtonAll: false
    };
  },
  components: {
    Layout,
    "filters": Filter
  },
  beforeMount() {
    this.getAllReports();
  },
  methods: {
    getDate(date) {
      return getDateWithFormat(date);
    },
    getNumberWithSeparators(number) {
      return thousandSeparator(number);
    },
    getAllReports() {
      if(this.filtersValue.rutEmpresa){
        let path = "/GetOrdenes";
        let data;
        data = {
          rut: parseInt(this.filtersValue.rutEmpresa),
          patente: this.filtersValue.patent ? this.filtersValue.patent : "",
          fechaDesde: this.filtersValue.period[0] ? moment(this.filtersValue.period[0]).format('YYYY-MM-DD') : moment(new Date("2000-01-01")).format('YYYY-MM-DD'),
          fechaHasta: this.filtersValue.period[1] ? moment(this.filtersValue.period[1]).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),
        }
        this.isBusy = true;
        axios
          .post(path, data)
          .then((reports) => {
            this.tableData = reports.data.datos;
            this.totRegistros = reports.data.totalRegistros;
            this.isBusy = false;
          })
          .catch((error) => {
            if (error.response) {
              this.$bvToast.toast(this.$t("NoData.error.message").toString(), {
                title: this.$t("NoData.error.title").toString(),
                variant: "danger",
                solid: true,
              });
            }
            this.isBusy = false;
          });
      }      
    },
    getAllOrden() {
      this.isBusyButtonAll = true;
      let dataAll;
      dataAll = {
        rut: parseInt(this.filtersValue.rutEmpresa),
        patente: this.filtersValue.patent ? this.filtersValue.patent : "",
        fechaDesde: this.filtersValue.period[0] ? moment(this.filtersValue.period[0]).format('YYYY-MM-DD') : moment(new Date("2000-01-01")).format('YYYY-MM-DD'),
        fechaHasta: this.filtersValue.period[1] ? moment(this.filtersValue.period[1]).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),
        pagina: 1,
        registros: this.totRegistros,
      };
      axios
          .post("/GetOrdenes", dataAll)
          .then((Response) => {
            toExcelThree(Response.data.datos, "Orden_Taller_");
            this.isBusyButtonAll = false;
          })
          .catch(() => {
            this.$bvToast.toast(this.$t("NoData.error.message").toString(), {
              title: this.$t("NoData.error.title").toString(),
              variant: "danger",
              solid: true,
            });
            this.isBusyButtonAll = false;
          });
    },
    downloadDocumento(row){
      this.buttonClicked = row.index;
      axios.get(`/GetPdfOT/${row.item.numeroOT}`)
          .then(documento => {
            if (documento.data.pdf) {
              const blob = this.b64toBlob(
                  documento.data.pdf,
                  "application/pdf"
              );
              let fileURL = window.URL.createObjectURL(blob);
              let fileLink = document.createElement("a");

              fileLink.href = fileURL;
              fileLink.setAttribute(
                  "download",
                  `${row.item.asignacion.trim()}.pdf`
              );
              document.body.appendChild(fileLink);

              fileLink.click();
              this.buttonClicked = undefined;
            }else {
              this.$bvToast.toast(this.$t("lease.pdf.error.nonFound").toString(), {
                title: this.$t("lease.pdf.error.download").toString(),
                variant: "danger",
                solid: true,
              });
              this.buttonClicked = undefined;
            }
          })
          .catch(() => {
            this.$bvToast.toast(this.$t("lease.pdf.error.nonFound").toString(), {
              title: this.$t("lease.pdf.error.download").toString(),
              variant: "danger",
              solid: true,
            });
            this.buttonClicked = undefined;
          });
    },
    b64toBlob(b64Data, contentType = "", sliceSize = 512) {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (
          let offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
      ) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      return new Blob(byteArrays, {type: contentType});
    },
  },
  watch:{
    currentPage(){
      this.getAllReports();  
    }
  }
};
</script>

<style>
.spacingButton{
  margin-left: 1rem;
}
</style>
